import useProductVariant from '@/api/inventory-management/products/useProductVariant';
import { RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import { Skeleton } from '@/components/ui/skeleton';
import { XCircleIcon } from '@phosphor-icons/react';
import { T, useGT } from 'gt-react';

export function ProductVariantListItem({
  variantId,
  isSelected,
  onSelect,
}: {
  variantId: string;
  isSelected: boolean;
  onSelect: (variantId: string, productId: string) => void;
}) {
  const gt = useGT();
  const { data, isLoading, error } = useProductVariant(variantId);
  const productVariant = data?.productVariant;

  return (
    <li
      className="border-b last:border-b-0"
      onClick={() => {
        if (productVariant) {
          onSelect(productVariant.id, productVariant.productId);
        }
      }}
    >
      <Label className="flex items-center p-1 gap-1">
        <RadioGroupItem value={variantId} checked={isSelected} />
        {isLoading ? (
          <Skeleton className="w-full" />
        ) : error ? (
          <>
            <XCircleIcon className="text-destructive" />
            <span className="text-destructive">
              {error.message ||
                gt('Error loading variant', {
                  context:
                    'fallback error message when a product variant fails to load',
                })}
            </span>
          </>
        ) : productVariant ? (
          <span>
            {(typeof productVariant.originMetadata?.NAMEINVC === 'string'
              ? productVariant.originMetadata.NAMEINVC
              : undefined) ||
              gt('(No name)', {
                context:
                  'fallback display name for a product variant with no name set',
              })}
          </span>
        ) : (
          <span>
            <T context="message shown when a product variant ID does not match any known variant">
              Variant not found
            </T>
          </span>
        )}
      </Label>
    </li>
  );
}
